var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import styled from "styled-components";
import person from "../../images/table/person.png";
import { checkAndSetImgUrl } from "../../utils/utils";
import { media } from "../../const/media";
export var CustomTable = styled.table(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n\n  @media ",
      " {\n    display: flex;\n  }\n\n  & tbody {\n    font-family: Gotham Pro;\n    color: #313131;\n    font-size: 16px;\n    white-space: pre-wrap;\n    overflow: auto;\n  }\n\n  & th {\n    padding: 10px;\n    text-align: left;\n    border-left: 2px solid #dadde0;\n    background-color: #e8eaec;\n    text-align: center;\n  }\n\n  & th:first-child {\n    max-width: 120px;\n    color: #777777;\n    font-weight: 400;\n    text-align: center;\n    border-left: none;\n  }\n\n  & :nth-child(2) {\n    max-width: 180px;\n  }\n\n  & :nth-child(4) {\n    max-width: 120px;\n  }\n\n  & :nth-child(5) {\n    max-width: 180px;\n  }\n\n  & tr {\n    border-top: 2px solid #e8eaec;\n  }\n\n  & tr:first-child {\n    border-top: none;\n  }\n\n  & td {\n    padding: 8px;\n    background-color: #f8f8f8;\n    border-left: 2px solid #e8eaec;\n  }\n\n  & td:first-child {\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #777777;\n    text-align: center;\n    border-left: none;\n  }\n\n  & td:nth-child(4) {\n    min-width: 180px;\n  }\n\n  & tr:first-child th:first-child {\n    border-top-left-radius: 24px;\n  }\n\n  & tr:first-child th:last-child {\n    border-top-right-radius: 24px;\n  }\n\n  & tr:last-child td:first-child {\n    border-bottom-left-radius: 24px;\n  }\n\n  & tr:last-child td:last-child {\n    border-bottom-right-radius: 24px;\n  }\n\n  img {\n    display: block;\n    max-width: 100px;\n    height: 100px;\n    object-fit: cover;\n    cursor: pointer;\n  }\n",
    ])),
  media.mobile
);
export var Table = function Table(_ref) {
  var _Object$keys;

  var headList = _ref.headList,
    handleModalState = _ref.handleModalState,
    handleCurrentItem = _ref.handleCurrentItem,
    app_api = _ref.app_api,
    members = _ref.members;

  var showModal = function showModal(id, groupName) {
    handleModalState();
    handleCurrentItem(id, groupName);
  };

  return /*#__PURE__*/ React.createElement(
    CustomTable,
    null,
    /*#__PURE__*/ React.createElement(
      "tbody",
      null,
      /*#__PURE__*/ React.createElement(
        "tr",
        null,
        headList.map(function (h) {
          return /*#__PURE__*/ React.createElement(
            "th",
            {
              key: h.name,
            },
            h.label
          );
        })
      ),
      (_Object$keys = Object.keys(members)) == null
        ? void 0
        : _Object$keys.map(function (item) {
            var _members$item;

            return (_members$item = members[item]) == null
              ? void 0
              : _members$item.map(function (el) {
                  return /*#__PURE__*/ React.createElement(
                    "tr",
                    {
                      key: el._id,
                    },
                    headList.map(function (h) {
                      return /*#__PURE__*/ React.createElement(
                        "td",
                        {
                          key: h.label,
                        },
                        h.name == "picture"
                          ? /*#__PURE__*/ React.createElement("img", {
                              src: !!el[h.name] ? "" + app_api + el[h.name] : person,
                              onError: checkAndSetImgUrl,
                              alt: "image",
                              onClick: function onClick() {
                                return showModal(el._id, item);
                              },
                            })
                          : h.name == "teams_squad"
                          ? item
                          : h.name == "birthday"
                          ? new Date(el.birthday * 1000).toLocaleDateString()
                          : el[h.name]
                      );
                    })
                  );
                });
          })
    )
  );
};
